import Swiper from "swiper";
import {Pagination} from "swiper/modules";

export const home = (slider) => {
    new Swiper(slider, {
        modules: [Pagination],
        spaceBetween: 16,
        slidesPerView: 'auto',
        breakpoints: {
            991: {
                slidesPerView: 5,
            }
        },
        pagination: {
            el: slider.querySelector('.swiper-pagination'),
            clickable: true,
        },
    });
};
